export const checkEditAccess = (userInfo, selectedUser) => {
  const currentUserRole = userInfo.role.name;
  const userOrgId = userInfo.organization?.org_id || userInfo.org_id;
  const selectedOrgId =
    selectedUser.org_id || selectedUser.organization?.org_id;

  if (currentUserRole === "super-admin") {
    return true;
  } else if (userInfo.user_id === selectedUser.user_id) {
    return true;
  } else if (
    currentUserRole === "admin" &&
    selectedUser.role?.name !== "super-admin" &&
    String(userOrgId) === String(selectedOrgId)
  ) {
    return true;
  } else {
    return false;
  }
};

export const canManageTaskComment = (userInfo, comment) => {
  if (!userInfo || !comment) {
    return false;
  }
  if (userInfo.user_id === comment.user_id) {
    return true;
  }
  return userInfo.role?.name === "super-admin";
};

export const checkDeleteAccess = (userInfo, selectedUser) => {
  const currentUserRole = userInfo.role.name;
  const userOrgId = userInfo.organization?.org_id || userInfo.org_id;
  const selectedOrgId =
    selectedUser.org_id || selectedUser.organization?.org_id;

  if (userInfo.user_id === selectedUser.user_id) {
    return false;
  } else if (currentUserRole === "super-admin") {
    return true;
  } else if (
    currentUserRole === "admin" &&
    selectedUser.role?.name !== "super-admin" &&
    String(userOrgId) === String(selectedOrgId)
  ) {
    return true;
  } else {
    return false;
  }
};

export const canChangeUserPassword = (userInfo, selectedUser) => {
  if (!userInfo || !selectedUser) {
    return false;
  }

  // Contacts use role "none". Older users may have is_login_enabled=false
  // even when they are real login users.
  const roleName = selectedUser.role?.name;
  const isLoginUser =
    selectedUser.is_login_enabled === true ||
    (Boolean(roleName) && roleName !== "none");

  if (!isLoginUser) {
    return false;
  }

  if (userInfo.user_id === selectedUser.user_id) {
    return true;
  }

  const currentUserRole = userInfo.role?.name;
  if (currentUserRole === "super-admin") {
    return true;
  }

  const userOrgId = userInfo.organization?.org_id || userInfo.org_id;
  const selectedOrgId =
    selectedUser.org_id || selectedUser.organization?.org_id;

  return (
    currentUserRole === "admin" &&
    selectedUser.role?.name !== "super-admin" &&
    String(userOrgId) === String(selectedOrgId)
  );
};
